var _path, _path2, _path3, _path4, _polygon, _polygon2, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuickSetup(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.71,349.14H264a5.87,5.87,0,0,1-5.86-5.86V80A5.87,5.87,0,0,1,264,74.15H444.71A5.87,5.87,0,0,1,450.57,80V343.28A5.87,5.87,0,0,1,444.71,349.14ZM264,74.4A5.61,5.61,0,0,0,258.35,80V343.28a5.61,5.61,0,0,0,5.61,5.61H444.71a5.61,5.61,0,0,0,5.61-5.61V80a5.61,5.61,0,0,0-5.61-5.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.28,349.14H55.53a5.87,5.87,0,0,1-5.86-5.86V80a5.87,5.87,0,0,1,5.86-5.86H236.28A5.87,5.87,0,0,1,242.14,80V343.28A5.87,5.87,0,0,1,236.28,349.14ZM55.53,74.4A5.61,5.61,0,0,0,49.92,80V343.28a5.61,5.61,0,0,0,5.61,5.61H236.28a5.61,5.61,0,0,0,5.61-5.61V80a5.61,5.61,0,0,0-5.61-5.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.79,
    y: 410.21,
    width: 500,
    height: 0.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.55,
    y: 151.33,
    width: 170.3,
    height: 69.54,
    transform: "translate(373.8 -1.59) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.74,
    y: 104.77,
    width: 61.91,
    height: 162.66,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.65 104.77 218.65 113.04 156.74 174.94 156.74 158.38 210.36 104.77 218.65 104.77",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.65 155.8 218.65 180.04 156.74 241.94 156.74 217.71 218.65 155.8",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.45,
    y: 100.95,
    width: 4.61,
    height: 170.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.26,
    y: 151.33,
    width: 170.3,
    height: 69.54,
    transform: "translate(494.51 -122.31) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.46,
    y: 104.77,
    width: 61.91,
    height: 162.66,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.37 104.77 339.37 113.04 277.46 174.94 277.46 158.38 331.08 104.77 339.37 104.77",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.37 155.8 339.37 180.04 277.46 241.94 277.46 217.71 339.37 155.8",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.16,
    y: 100.95,
    width: 4.61,
    height: 170.3,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.96,
    cy: 119.63,
    r: 20.47,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 101.96,
    cy: 119.63,
    r: 18.86,
    transform: "translate(-37.61 191.92) rotate(-76.94)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.31,
    y: 102.48,
    width: 0.71,
    height: 3.93,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.31,
    y: 132.74,
    width: 0.71,
    height: 3.93,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.56,
    y: 119.22,
    width: 3.93,
    height: 0.71,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.82,
    y: 119.22,
    width: 3.93,
    height: 0.71,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.39,
    y: 108.53,
    width: 3.93,
    height: 0.71,
    transform: "translate(-44.08 111.34) rotate(-45)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 129.92,
    width: 3.93,
    height: 0.71,
    transform: "translate(-65.48 102.52) rotate(-45.02)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.61,
    y: 106.91,
    width: 0.71,
    height: 3.93,
    transform: "translate(-50.35 96.24) rotate(-45.01)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 128.31,
    width: 0.71,
    height: 3.93,
    transform: "translate(-59.21 117.59) rotate(-44.99)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.45,
    y: 117.12,
    width: 0.6,
    height: 7.17,
    transform: "translate(-45.94 173.95) rotate(-68.51)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.96 119.88 90.96 119.88 90.96 119.27 101.36 119.27 101.36 110.74 101.96 110.74 101.96 119.88",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.01 124.03 358.41 123.08 393.4 101.03 427.54 123.57 426.92 124.51 393.39 102.37 359.01 124.03",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.81,
    y: 123.13,
    width: 70.48,
    height: 44.08,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.96,
    y: 111.89,
    width: 40.18,
    height: 66.57,
    transform: "translate(538.22 -247.87) rotate(90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.97,
    y: 137.68,
    width: 4.25,
    height: 4.25,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.53,
    y: 137.68,
    width: 4.25,
    height: 4.25,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.08,
    y: 137.68,
    width: 4.25,
    height: 4.25,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.64,
    y: 137.68,
    width: 4.25,
    height: 4.25,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.2,
    y: 137.68,
    width: 4.25,
    height: 4.25,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.76,
    y: 137.68,
    width: 4.25,
    height: 4.25,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.31,
    y: 137.68,
    width: 4.25,
    height: 4.25,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.87,
    y: 137.68,
    width: 4.25,
    height: 4.25,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.43,
    y: 137.68,
    width: 4.25,
    height: 4.25,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.97,
    y: 143.54,
    width: 4.25,
    height: 4.25,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.53,
    y: 143.54,
    width: 4.25,
    height: 4.25,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.08,
    y: 143.54,
    width: 4.25,
    height: 4.25,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.64,
    y: 143.54,
    width: 4.25,
    height: 4.25,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.2,
    y: 143.54,
    width: 4.25,
    height: 4.25,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.76,
    y: 143.54,
    width: 4.25,
    height: 4.25,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.31,
    y: 143.54,
    width: 4.25,
    height: 4.25,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.87,
    y: 143.54,
    width: 4.25,
    height: 4.25,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.43,
    y: 143.54,
    width: 4.25,
    height: 4.25,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.97,
    y: 149.39,
    width: 4.25,
    height: 4.25,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.53,
    y: 149.39,
    width: 4.25,
    height: 4.25,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.08,
    y: 149.39,
    width: 4.25,
    height: 4.25,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.64,
    y: 149.39,
    width: 4.25,
    height: 4.25,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.2,
    y: 149.39,
    width: 4.25,
    height: 4.25,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.76,
    y: 149.39,
    width: 4.25,
    height: 4.25,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.31,
    y: 149.39,
    width: 4.25,
    height: 4.25,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.87,
    y: 149.39,
    width: 4.25,
    height: 4.25,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.43,
    y: 149.39,
    width: 4.25,
    height: 4.25,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.97,
    y: 155.69,
    width: 4.25,
    height: 4.25,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.53,
    y: 155.69,
    width: 4.25,
    height: 4.25,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.08,
    y: 155.69,
    width: 4.25,
    height: 4.25,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.64,
    y: 155.69,
    width: 4.25,
    height: 4.25,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.41,
    y: 129.02,
    width: 37.84,
    height: 3.68,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.65,101.43a2.14,2.14,0,1,1-2.14-2.14A2.14,2.14,0,0,1,395.65,101.43Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.25,454.44c0,3.38-93.52,6.13-208.87,6.13S46.5,457.82,46.5,454.44,140,448.3,255.38,448.3,464.25,451.05,464.25,454.44Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.77,236l2.91-.84-1.85-6.46-3.37,1a9.12,9.12,0,0,0-3.52-2.47v-3.4H61.22v3.4A9.11,9.11,0,0,0,58.36,229l-3-1.44-2.95,6,2.95,1.44c0,.25,0,.49,0,.74a9.2,9.2,0,0,0,1.17,4.48h0L54.33,243l5.25,4.2,2.15-2.7a9.29,9.29,0,0,0,2.85.45,9.07,9.07,0,0,0,2.1-.24l1.94,2.73,5.48-3.89-1.89-2.67A9,9,0,0,0,73.77,236Zm-15.24-.24a6,6,0,1,1,6,6A6.06,6.06,0,0,1,58.53,235.79Z",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.77,236l2.91-.84-1.85-6.46-3.37,1a9.12,9.12,0,0,0-3.52-2.47v-3.4H61.22v3.4A9.11,9.11,0,0,0,58.36,229l-3-1.44-2.95,6,2.95,1.44c0,.25,0,.49,0,.74a9.2,9.2,0,0,0,1.17,4.48h0L54.33,243l5.25,4.2,2.15-2.7a9.29,9.29,0,0,0,2.85.45,9.07,9.07,0,0,0,2.1-.24l1.94,2.73,5.48-3.89-1.89-2.67A9,9,0,0,0,73.77,236Zm-15.24-.24a6,6,0,1,1,6,6A6.06,6.06,0,0,1,58.53,235.79Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.52,130.45l2.91-.84-1.85-6.46-3.36,1a9.24,9.24,0,0,0-3.53-2.46v-3.4H447v3.4a9.11,9.11,0,0,0-2.86,1.78L441.16,122l-3,6,3,1.44c0,.25,0,.49,0,.74a9.2,9.2,0,0,0,1.17,4.48h0l-2.21,2.77,5.25,4.2,2.15-2.7a9.29,9.29,0,0,0,2.85.45,9.16,9.16,0,0,0,2.11-.24l1.93,2.73,5.48-3.9L458,135.33A9,9,0,0,0,459.52,130.45Zm-15.23-.24a6,6,0,1,1,6,6A6,6,0,0,1,444.29,130.21Z",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.52,130.45l2.91-.84-1.85-6.46-3.36,1a9.24,9.24,0,0,0-3.53-2.46v-3.4H447v3.4a9.11,9.11,0,0,0-2.86,1.78L441.16,122l-3,6,3,1.44c0,.25,0,.49,0,.74a9.2,9.2,0,0,0,1.17,4.48h0l-2.21,2.77,5.25,4.2,2.15-2.7a9.29,9.29,0,0,0,2.85.45,9.16,9.16,0,0,0,2.11-.24l1.93,2.73,5.48-3.9L458,135.33A9,9,0,0,0,459.52,130.45Zm-15.23-.24a6,6,0,1,1,6,6A6,6,0,0,1,444.29,130.21Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icon--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.67,201.06a18.29,18.29,0,0,1-5.16-.74.36.36,0,0,1-.25-.46.37.37,0,0,1,.46-.26,17.51,17.51,0,0,0,4.94.71.41.41,0,0,1,.41.38.34.34,0,0,1-.33.37v-.37Zm5.11-.74a.38.38,0,0,1-.36-.27.36.36,0,0,1,.25-.46,17.61,17.61,0,0,0,4.53-2.1.38.38,0,0,1,.52.11.38.38,0,0,1-.11.52,18.21,18.21,0,0,1-4.72,2.18ZM88,198.22a.36.36,0,0,1-.2-.06,18.59,18.59,0,0,1-3.94-3.41.38.38,0,0,1,0-.53.37.37,0,0,1,.53,0,18.1,18.1,0,0,0,3.77,3.27.36.36,0,0,1,.12.51A.38.38,0,0,1,88,198.22Zm23.27-3.4a.38.38,0,0,1-.25-.09.38.38,0,0,1,0-.53,17.36,17.36,0,0,0,2.69-4.2.38.38,0,0,1,.69.31,18.37,18.37,0,0,1-2.81,4.38A.35.35,0,0,1,111.25,194.82Zm-29.89-4.23a.37.37,0,0,1-.34-.22,18,18,0,0,1-1.47-5,.37.37,0,0,1,.32-.42.36.36,0,0,1,.42.31,17.37,17.37,0,0,0,1.41,4.79.37.37,0,0,1-.18.5A.45.45,0,0,1,81.36,190.59Zm34.06-5h0a.38.38,0,0,1-.32-.43,17.39,17.39,0,0,0,0-5,.37.37,0,0,1,.32-.42.37.37,0,0,1,.42.31,18,18,0,0,1,0,5.21A.38.38,0,0,1,115.42,185.63Zm-35.51-5h0a.38.38,0,0,1-.32-.42,18.2,18.2,0,0,1,1.47-5,.37.37,0,0,1,.49-.19.39.39,0,0,1,.19.5,17,17,0,0,0-1.4,4.79A.38.38,0,0,1,79.91,180.6Zm34-4.95a.39.39,0,0,1-.34-.22,17.23,17.23,0,0,0-2.72-4.19.38.38,0,0,1,0-.53.37.37,0,0,1,.53,0,18.13,18.13,0,0,1,2.83,4.36.38.38,0,0,1-.18.5A.47.47,0,0,1,114,175.65ZM84.1,171.42a.38.38,0,0,1-.24-.09.37.37,0,0,1,0-.53,18.34,18.34,0,0,1,3.93-3.42.38.38,0,0,1,.52.11.37.37,0,0,1-.12.52,17.56,17.56,0,0,0-3.76,3.28A.37.37,0,0,1,84.1,171.42ZM107.32,168a.41.41,0,0,1-.21-.05,17.09,17.09,0,0,0-4.54-2.07.38.38,0,0,1-.25-.47.36.36,0,0,1,.46-.25,18.1,18.1,0,0,1,4.74,2.15.38.38,0,0,1,.11.52A.37.37,0,0,1,107.32,168Zm-14.74-2.09a.37.37,0,0,1-.1-.73,17.83,17.83,0,0,1,5.15-.75h0a.38.38,0,0,1,0,.75,17.17,17.17,0,0,0-4.94.72Z",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 97.66,
    cy: 182.76,
    r: 14.93,
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.07,189.24h0a1,1,0,0,1-.71-.33l-4.5-5a1,1,0,0,1,1.48-1.34l3.81,4.22,9.63-9.28a1,1,0,0,1,1.42,0,1,1,0,0,1,0,1.41L95.76,189A1,1,0,0,1,95.07,189.24Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Rocket--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.3,211.39s-30.4,15.33-39.55,53.72c-6.67,28-4.65,80.84,7.37,85.08s13.36-28.48,13.46-40.11,11-25.83,20.71-26.68C205.29,283.4,207.19,222,203.3,211.39Z",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.85,219c-7.19,2.74-13.1,8-17.89,13.88a90.79,90.79,0,0,0-12.47,21.21,114.48,114.48,0,0,0-7.65,25.34,171.9,171.9,0,0,0-2.13,27.76c-.16,11.37-.44,23.21,4,33.93.17.43.88.24.7-.19-3.84-9.34-4.07-19.54-4-29.49.08-9.39.22-18.82,1.55-28.13,2.38-16.54,8.41-33.27,18.22-46.89,5.09-7.06,11.62-13.57,19.88-16.72.44-.17.25-.87-.19-.7Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.45,211.39s30.4,15.33,39.55,53.72c6.67,28,4.65,80.84-7.37,85.08s-13.36-28.48-13.46-40.11-11-25.83-20.71-26.68C305.46,283.4,303.56,222,307.45,211.39Z",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.71,219.69c7.23,2.76,13.14,8.12,17.9,14.11a90.63,90.63,0,0,1,12.16,21A114,114,0,0,1,340.28,280c1.59,9.12,1.91,18.39,2,27.63.15,11.17.39,22.76-3.94,33.29-.17.43.53.62.7.19,3.89-9.46,4.09-19.82,4-29.9-.08-9.51-.25-19.06-1.63-28.49a113.68,113.68,0,0,0-7.16-26.17,95.49,95.49,0,0,0-11.71-21.37C317.47,228.31,311,222.09,302.9,219c-.44-.17-.63.53-.19.7Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,328.06H213s-15.38-59.1-9.35-125.37a163.48,163.48,0,0,1,13.2-50.88c.1-.25.21-.5.32-.74,1.76-4,3.61-7.77,5.51-11.36a180.41,180.41,0,0,1,27.67-38.87,6.65,6.65,0,0,1,10,0,180.59,180.59,0,0,1,28.38,40.22c1.9,3.67,3.75,7.54,5.5,11.6l.31.72a164.13,164.13,0,0,1,12.52,49.31C313.08,269,297,328.06,297,328.06Z",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297,328.06H213s-15.38-59.1-9.35-125.37a163.48,163.48,0,0,1,13.2-50.88c.1-.25.21-.5.32-.74,1.76-4,3.61-7.77,5.51-11.36a180.41,180.41,0,0,1,27.67-38.87,6.65,6.65,0,0,1,10,0,180.59,180.59,0,0,1,28.38,40.22c1.9,3.67,3.75,7.54,5.5,11.6l.31.72a164.13,164.13,0,0,1,12.52,49.31C313.08,269,297,328.06,297,328.06Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 224.72,
    y: 319.64,
    width: 62.99,
    height: 0.96,
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.91,350.56H214c-6.05-8.71.35-22.5.35-22.5h82.84S303.56,339.31,298.91,350.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.46,358.46H235c-3-4.36.18-11.25.18-11.25H276.6S279.78,352.83,277.46,358.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.48,358.46H235.14c-8.57,4.55-29.89,15.41-26.91,33.81h97.25C308.46,373.87,286.05,363,277.48,358.46Z",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.58,
    y: 388.38,
    width: 103.83,
    height: 8.01,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.73,141.06c-7.66,5.48-19.38,11.62-33.38,11.62a48.27,48.27,0,0,1-32.68-13q1.2-2.27,2.42-4.42l.39-.67a178.93,178.93,0,0,1,24.86-33.78,6.65,6.65,0,0,1,10,0,178.59,178.59,0,0,1,24.92,33.87l.39.69Q287.22,138.14,288.73,141.06Z",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.66,135.4a52.61,52.61,0,0,1-7.79,4.63,51.63,51.63,0,0,1-30.93,4.44,52.64,52.64,0,0,1-21.85-9.18l.39-.67a51.3,51.3,0,0,0,8.4,4.95,50.68,50.68,0,0,0,30.78,4,51.78,51.78,0,0,0,20.61-8.85Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.61,213.27c-3.85-38.88-6.86-54.44-7.21-56.15,1.45-.79,2.81-1.59,4-2.37.73-.45,1.43-.91,2.1-1.37l-.31-.72c-.71.48-1.44,1-2.2,1.44-8,5.05-20.85,11.08-36.33,11.08a59.52,59.52,0,0,1-34.11-10.72c-1.65-1.14-3.12-2.29-4.43-3.39-.11.24-.22.49-.32.74,1.27,1.06,2.7,2.16,4.28,3.27,1,.7,2.13,1.43,3.32,2.15-.43,2.16-3.4,17.85-7.18,56-3,29.8-.26,59.45,2.52,79.08a350.5,350.5,0,0,0,6.82,35.81.36.36,0,0,0,.35.27l.09,0a.37.37,0,0,0,.26-.44,348.89,348.89,0,0,1-6.8-35.74c-2.78-19.58-5.47-49.16-2.52-78.89,3.66-36.94,6.56-52.79,7.12-55.72A60,60,0,0,0,255.7,166a68,68,0,0,0,32-8.46c.5,2.54,3.43,18.3,7.15,55.85,2.95,29.73.26,59.31-2.52,78.89a348.89,348.89,0,0,1-6.8,35.74.37.37,0,0,0,.26.44l.09,0a.36.36,0,0,0,.35-.27,350.5,350.5,0,0,0,6.82-35.81C295.87,272.72,298.57,243.07,295.61,213.27Z",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.7,254.54a27.83,27.83,0,1,1,27.82-27.82A27.85,27.85,0,0,1,255.7,254.54Zm0-54.92a27.1,27.1,0,1,0,27.1,27.1A27.13,27.13,0,0,0,255.7,199.62Z",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.77,226.71a21.07,21.07,0,0,1-21.07,21.07h-.49a20.85,20.85,0,0,1-10.13-2.86,21.25,21.25,0,0,1-6.14-5.42,20.94,20.94,0,0,1-4.31-12.78,22.22,22.22,0,0,1,.14-2.45,21.1,21.1,0,0,1,18.47-18.47,22.26,22.26,0,0,1,2.46-.14,21.09,21.09,0,0,1,21.06,20.57C276.77,226.39,276.77,226.55,276.77,226.71Z",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.47,210l-29.53,29.53a20.94,20.94,0,0,1-4.31-12.78,22.22,22.22,0,0,1,.14-2.45l18.47-18.47a22.26,22.26,0,0,1,2.46-.14A21,21,0,0,1,268.47,210Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.76,226.22l-21.55,21.55a20.85,20.85,0,0,1-10.13-2.86l28.81-28.8A20.75,20.75,0,0,1,276.76,226.22Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.66 411.44 246.97 417.13 237.71 431.42 233.77 437.49 223.24 453.73 219.13 453.73 229.83 431.42 233.77 423.2 236.25 418.02 236.25 418.02 239.41 411.44 250.66 411.44",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.66 411.44 246.97 417.13 237.71 431.42 233.77 437.49 223.24 453.73 219.13 453.73 229.83 431.42 233.77 423.2 236.25 418.02 236.25 418.02 239.41 411.44 250.66 411.44",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.69 411.44 293.5 413.28 281.74 431.42 277.8 437.49 267.27 453.73 263.17 453.73 273.86 431.42 277.8 423.2 282.11 414.22 283.44 411.44 294.69 411.44",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.69 411.44 293.5 413.28 281.74 431.42 277.8 437.49 267.27 453.73 263.17 453.73 273.86 431.42 277.8 423.2 282.11 414.22 283.44 411.44 294.69 411.44",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.73,
    y: 396.39,
    width: 87.2,
    height: 15.05,
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.73,
    y: 396.39,
    width: 87.2,
    height: 15.05,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.41 453.73 244.3 453.73 233.77 437.49 229.83 431.42 221.92 419.21 216.88 411.44 228.13 411.44 231.48 418.41 233.77 423.2 237.71 431.42 248.41 453.73",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.44 453.73 288.33 453.73 277.8 437.49 273.86 431.42 263.7 415.74 260.91 411.44 272.16 411.44 273.82 414.9 277.8 423.2 281.74 431.42 292.44 453.73",
    style: {
      fill: "#D0D0D0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-34"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393.59,208.86a163.72,163.72,0,0,1-11.27,19.47c-.78,1.11-1.56,2.19-2.36,3.21-4.08,5.25-8.36,9.09-11.75,8.18-18.87-5.06-30.79-21-30.79-21l3.54-4s22.76,8.87,24.54,8.7,13-28.25,13-28.25Z",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.06,221.45l-1.74,6.88c-.78,1.11-1.56,2.19-2.36,3.21a21.15,21.15,0,0,0-1.13-5.92c-1.41-3.91-6.55-8.84-4.33-14a81.55,81.55,0,0,0,4-12.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.57,236.93A8.16,8.16,0,0,0,363.4,238c-.32.35-.83-.17-.52-.52a8.89,8.89,0,0,1,12.06-1.2c.37.28,0,.91-.37.63Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.49,226.6l-24.39-.5a3.71,3.71,0,0,1-3.4-2.65l-7.61-32a2,2,0,0,1,2.17-2.53l24.39.51a3.7,3.7,0,0,1,3.4,2.64l7.61,32A2,2,0,0,1,368.49,226.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.49,226.6l-24.39-.5a3.71,3.71,0,0,1-3.4-2.65l-7.61-32a2,2,0,0,1,2.17-2.53l24.39.51a3.7,3.7,0,0,1,3.4,2.64l7.61,32A2,2,0,0,1,368.49,226.6Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,226.55l-24.4-.5a3.72,3.72,0,0,1-3.39-2.65l-7.62-32a2,2,0,0,1,2.17-2.53l24.4.5a3.72,3.72,0,0,1,3.39,2.65l7.61,32A2,2,0,0,1,366,226.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.85,208.58a4.64,4.64,0,0,0,4.22,3.38,2.53,2.53,0,0,0,2.68-3.24,4.63,4.63,0,0,0-4.21-3.39A2.55,2.55,0,0,0,344.85,208.58Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.58,210.63s5.34-.3,6.19.8-4.51,2.16-4.51,2.16,3.16-.09,4,.66-3.12,1.95-3.12,1.95,2.11,0,2.19,1.18-.72,1.58-1.89,1.86a3.21,3.21,0,0,1-2.8-.64c-.46-.46-.07-1.65-.07-1.65s-2-1-2.08-1.76a1.67,1.67,0,0,1,.48-1.28,1.75,1.75,0,0,1-1.29-1.07,1.57,1.57,0,0,1,.1-1.48,22.21,22.21,0,0,1-1.06-2.71c-.26-1,1.51-1.79,2.58-2.42s3,1.57,4.76,2c0,0,.9.55-.06,1.22s-3-.34-3.48-.3S336.58,210.63,336.58,210.63Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,148.33s-6.63,2.63-5,7.92-2.67,4.8-3.18,9.93,8.2,6.71,5.83,11.3-6,5.92-3.62,10.39,5.56,9.59,5.56,12.9c0,7.84,15-11.48,26.55-8.3s14.58-8.15,9.86-10.77-10.84-6.47-9.05-13.32,3.08-10-2.17-13.56-2.37-4.15-5.4-7.42c-2.73-2.94-6.71.09-11-1.18S382,148.33,382,148.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.08,173.42a2.46,2.46,0,1,0,2.16-2.73A2.46,2.46,0,0,0,384.08,173.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.22 433.74 376.55 444.75 370.75 444.75 370.48 433.74 379.22 433.74",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.9,452.54c.32-3.59,1.89-4.66,3.84-4.78s9.25-2.55,9.25-2.55,1.51-2.28,2.85-2.74,2.61.89,2.61.89l3.65-.44s1.09-1.64,1.84-.21c1.16,2.23,1,8.39.91,9.83Z",
    style: {
      fill: "#D0D0D0"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M354.38,451.6l4.52,0,19.79-.1c.25,0,.2-.39-.05-.38H377.3s0,0,0-.05a3.67,3.67,0,0,1,1.34-5.22c.21-.11,0-.45-.23-.33a4,4,0,0,0-1.49,5.6h-2.79l-19.79.1C354.07,451.22,354.12,451.61,354.38,451.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M368.09,446.76c-1-1.21-2.53-1.55-3.63-.64-.18.15-.41-.18-.24-.33,1.26-1,3-.59,4.17.78.17.2-.13.39-.3.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,447.41c-1-1.21-2.53-1.56-3.63-.64-.17.14-.41-.19-.23-.33,1.25-1.05,3-.6,4.17.77.17.2-.14.39-.31.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.93,448.05c-1-1.21-2.53-1.55-3.63-.64-.18.15-.41-.19-.24-.33,1.26-1.05,3-.59,4.17.77.17.21-.13.4-.3.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.22,289.44a383.65,383.65,0,0,1-7.7,43.94q-1.83,8.06-4.16,17.18c4.27,35.26-12.44,86.2-12.44,86.2l-8.95-.2s-1.12-56.93-.07-86.73c1.72-48.83,7.67-95.34,7.67-95.34l24.38-.1S406.16,261.73,403.22,289.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.22,289.44a383.65,383.65,0,0,1-7.7,43.94c-5.13-19.53,4.15-61.21,4.15-61.21Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.94 438.67 368.66 434.83 380.6 434.83 379.92 438.67 368.94 438.67",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "416.33 433.74 413.65 444.75 407.85 444.75 407.59 433.74 416.33 433.74",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.83 438.67 405.55 434.83 417.49 434.83 416.81 438.67 405.83 438.67",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391,452.54c.31-3.59,1.89-4.66,3.84-4.78s9.25-2.55,9.25-2.55,1.51-2.28,2.84-2.74,2.62.89,2.62.89l3.64-.44s1.09-1.64,1.85-.21c1.16,2.23,1,8.39.91,9.83Z",
    style: {
      fill: "#D0D0D0"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M391.48,451.6l4.53,0,19.79-.1c.25,0,.2-.39-.06-.38h-1.33l0-.05a3.68,3.68,0,0,1,1.35-5.22c.21-.11,0-.45-.23-.33a4,4,0,0,0-1.5,5.6h-2.79l-19.78.1C391.18,451.22,391.23,451.61,391.48,451.6Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M405.2,446.76c-1-1.21-2.54-1.55-3.63-.64-.18.15-.42-.18-.24-.33,1.26-1,3-.59,4.17.78.17.2-.14.39-.3.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.15,447.41c-1-1.21-2.53-1.56-3.63-.64-.17.14-.41-.19-.24-.33,1.26-1.05,3-.6,4.17.77.18.2-.13.39-.3.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,448.05c-1-1.21-2.54-1.55-3.63-.64-.18.15-.42-.19-.24-.33,1.26-1.05,3-.59,4.17.77.17.21-.14.4-.3.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.83,256.36s4.55,67.41,6,94.2c1.71,30.61,5.54,82.78,6.05,86.19h9.25c-1.06,1,11.88-45.79,6.66-83.92,4.89-36.46,10.84-63.16,3.17-97.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.78,258c-19.44,6.42-52.11,4.31-52.11-.14,0-12.54,4.44-26.64,3.25-34.81-9.19-6.43-2-12.24-2.81-21.77a14.12,14.12,0,0,1,11.72-15c1.66-.28,3.38-.56,5.07-.78l1-.13a102.74,102.74,0,0,1,13.59-.64c1.66,0,3.38,0,5.18.05s3.54.11,5.2.23a10.45,10.45,0,0,1,9.56,12.25,196.41,196.41,0,0,0-2.83,25.31c-.08,1.75-.14,3.44-.16,5.1a133.67,133.67,0,0,0,.79,17.4c0,.11,0,.22,0,.32q.42,3.45,1,6.36c.12.61.25,1.19.39,1.76C428,254.68,428.46,256.79,428.78,258Z",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.47,201.42a.63.63,0,1,1-.63-.63A.63.63,0,0,1,393.47,201.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392.46,
    cy: 207.02,
    r: 0.62,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392.46,
    cy: 212.72,
    r: 0.62,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.52,184.69c-4.6,8.09-15.43,12.93-15.43,12.93-1.47-3.62-1-9.43.81-12.16l1-.13A102.74,102.74,0,0,1,408.52,184.69Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.32,251.71c-19.15-2.11-37.61-20.17-37.61-20.17l35.94,12a10.33,10.33,0,0,0,.65,1.84Q426.72,248.8,427.32,251.71Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.88,226.55a47.7,47.7,0,0,0-.59,10.38,11.8,11.8,0,0,1-8.38.35,17.74,17.74,0,0,1-8.94-7.59s10.91,2.15,13.61,1.15c2.42-.9-3.37-19.64-3.56-20.17l8,10.91C425,223.28,424.9,224.93,424.88,226.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.78,187.87a1.72,1.72,0,0,1-.17.37c-1.57,2.47.13,4.72,2.83,4.53a6.49,6.49,0,0,0,.77-.11,4.71,4.71,0,0,0,2.53-1.41h0a58.87,58.87,0,0,1,6.7-6.16c-4-2.17-5.52-9.88-5.9-14.7l-6.29,8-1.17,1.75a14,14,0,0,1,1.36,3.09A5,5,0,0,1,393.78,187.87Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.83,184.69a14,14,0,0,1,6.73,0l-6.11,10.49c-3.21-2.34-6.9.7-13.36,2.44A33.64,33.64,0,0,0,405.83,184.69Z",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.83,184.69a14,14,0,0,1,6.73,0l-6.11,10.49c-3.21-2.34-6.9.7-13.36,2.44A33.64,33.64,0,0,0,405.83,184.69Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.72,185.17s-3.73-.69-5.89,1.07a57.93,57.93,0,0,0-1.75,8.26s3.59-1.79,6,3.12C393.09,197.62,391.87,189.79,394.72,185.17Z",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.72,185.17s-3.73-.69-5.89,1.07a57.93,57.93,0,0,0-1.75,8.26s3.59-1.79,6,3.12C393.09,197.62,391.87,189.79,394.72,185.17Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M394.45,183.23a14,14,0,0,0-1.36-3.09l1.17-1.75,4,.09A9.41,9.41,0,0,1,394.45,183.23Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M401.7,161.8c.63,7.92,1.06,11.25-2.26,15.82-5,6.88-14.66,5.89-17.6-1.68-2.64-6.82-3.23-18.62,3.86-22.8s15.37.75,16,8.66",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.49,151.65s-1.66,6.75,2.32,8.44,9.41-.63,9.41,4.51c0,2.9,4.55,2,4.27-.67s1.61-7.77-4-10.54A22.22,22.22,0,0,0,386.49,151.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,168.21a2.77,2.77,0,0,1-1.23-.33c-2.68-1.33-3.05-8.12-3.06-8.41l.51,0c0,.07.36,6.78,2.78,8a1.73,1.73,0,0,0,1.59.13c.89-.46,1.13-1.91,1.13-1.92l.5.08a3.37,3.37,0,0,1-1.39,2.29A1.82,1.82,0,0,1,398,168.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.88,153.86s-4.39,7-7.43,5.35,4.2-9.51,7-7.56S386.88,153.86,386.88,153.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.14,174s3.85-1.74,4.7-3.42c0,0,.57,3-1.45,4.11A2.45,2.45,0,0,1,385.14,174Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.21,165.31c.09.64-.18,1.2-.6,1.26s-.82-.41-.91-1,.17-1.2.59-1.26.83.41.92,1.05",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.79,166.39c.09.64-.18,1.2-.59,1.26s-.83-.41-.92-1.05.17-1.2.59-1.26.83.41.92,1",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.06,165.35l-1.59-.23s.95,1.09,1.59.23",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.57,166.26s-.86,1.84-1.85,3.48a1,1,0,0,0,.51,1.43,9.43,9.43,0,0,0,2.08.39Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.25,166.85a5.08,5.08,0,0,1-2.7,3.2c-1.67.73-2.81-1.06-2.59-3.07.2-1.81,1.3-4.37,3.1-4.24s2.76,2.28,2.19,4.11",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.91,
    y: 168.59,
    width: 0.33,
    height: 3.68,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 402.13,
    cy: 172.91,
    r: 1.34,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.06,163.64a.37.37,0,0,1-.26-.16,3,3,0,0,0-2.35-1.4.38.38,0,0,1-.38-.37.38.38,0,0,1,.37-.39,3.76,3.76,0,0,1,3,1.74.37.37,0,0,1-.1.52.33.33,0,0,1-.27.06",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.21,163.92a.35.35,0,0,1-.27-.08.38.38,0,0,1-.06-.53,3.77,3.77,0,0,1,3.13-1.47.38.38,0,1,1-.07.75,3.06,3.06,0,0,0-2.47,1.19.31.31,0,0,1-.26.14",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.48,164.27l-1.6-.23s1,1.09,1.6.23",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.93,191.71s13.75,37.36,11.55,49.59c-3.62,20.13-48.93-6.84-49.8-10.66l4.05-5.81s29.32,10.67,30.93,9.65-9.25-29.71-9.25-29.71S417,187.43,427.93,191.71Z",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.34,238.23a9.37,9.37,0,0,0-6.53,9.75c0,.47-.69.57-.73.1a10.1,10.1,0,0,1,7-10.52c.44-.15.73.53.28.67Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.41,230.84Z",
    style: {
      fill: "#a8681b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.91,226s-4.23-11.15-5.22-12.09-12.07-.9-13.21-1.19-.51,1.77,1.51,2.05,5.7,1.23,5.7,1.23-3.42-.24-4.07.54-3.51,6.38-2.72,9,4,2.78,5,3,0-2.53,0-2.53a9,9,0,0,0,2.67.68c1.58.18,3.64,3.21,5.2,3.9C392.73,232,396.27,226.78,394.91,226Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.45,216.4a10.26,10.26,0,0,0-2.65-.18c-.33,0-.39-.49-.06-.51a10.51,10.51,0,0,1,2.8.18.26.26,0,0,1-.09.51Z",
    style: {
      fill: "#994731"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.75,218.71c-1.52-.51-3.2-1-4.72-.23-.29.15-.59-.27-.3-.42,1.71-.91,3.51-.4,5.24.18.31.1.09.57-.22.47Z",
    style: {
      fill: "#994731"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.32,221a4.61,4.61,0,0,0-4.34.16c-.28.17-.58-.25-.29-.42a5.1,5.1,0,0,1,4.84-.21.26.26,0,0,1-.21.47Z",
    style: {
      fill: "#994731"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.82,226.37a4.16,4.16,0,0,1-2-2.64c-.07-.32.41-.5.49-.18A3.63,3.63,0,0,0,382,225.9c.29.16.07.63-.21.47Z",
    style: {
      fill: "#994731"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.37,225.14a1.39,1.39,0,0,0-1.51.4c-.22.25-.61-.08-.39-.33a1.92,1.92,0,0,1,2.12-.54c.31.12.09.59-.22.47Z",
    style: {
      fill: "#994731"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,171.52a2.29,2.29,0,0,1-1.7-1,5.81,5.81,0,0,1-1.18-2.74c-.37-2.25.43-4.27,1.78-4.49s2.77,1.42,3.14,3.67a5.81,5.81,0,0,1-.22,3,2.17,2.17,0,0,1-1.56,1.52Zm-.84-8-.21,0c-1.22.2-1.93,2.08-1.58,4.19a5.54,5.54,0,0,0,1.12,2.63,1.92,1.92,0,0,0,1.73.83,1.89,1.89,0,0,0,1.36-1.35,5.53,5.53,0,0,0,.21-2.84C382.44,165.06,381.29,163.57,380.14,163.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.88,170.36c-1.28,0-2.54-1.58-2.89-3.69s.43-4.27,1.78-4.49,2.77,1.42,3.14,3.67a5.81,5.81,0,0,1-.22,3,2.19,2.19,0,0,1-1.56,1.52Zm-.85-8-.21,0c-1.22.2-1.93,2.08-1.58,4.19s1.65,3.66,2.85,3.46a1.89,1.89,0,0,0,1.36-1.35,5.43,5.43,0,0,0,.21-2.84C389.33,163.9,388.18,162.41,387,162.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.31,167.9l-.17-.19A3.24,3.24,0,0,1,380,167l0,.26A3.07,3.07,0,0,0,378.31,167.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.83,166.57l-.2-.15a1.87,1.87,0,0,1,2.48-.46l-.13.22A1.61,1.61,0,0,0,382.83,166.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.76,165.53l-.12-.23c.05,0,5.49-2.91,11.17-1.93l0,.26C395.18,162.66,389.81,165.5,389.76,165.53Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-34"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "195 434.58 182.87 435.49 160.25 383.75 149.21 356.24 177.63 343.25 181.07 362.55 181.17 362.87 195 434.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.83 432.97 188.19 444.43 194.22 444.43 192.91 432.97 183.83 432.97",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "196.88 438.4 196.37 432.55 180.22 432.55 181.73 438.4 196.88 438.4",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.83,452.54c-.84-3.73-2.64-4.85-4.67-5s-10-2.65-10-2.65-1.9-2.37-3.35-2.85a2.61,2.61,0,0,0-2.59.93l-3.84-.47s-1.36-1.69-2-.21c-.67,1.71-.45,9.07-.41,10.23Z",
    style: {
      fill: "#D0D0D0"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M212.2,451.57l-4.7,0-20.56-.1a.2.2,0,0,1,0-.4h1.4a.07.07,0,0,1,0-.05c1-2.16-.17-4.34-2.15-5.43-.23-.12,0-.47.2-.34a4.59,4.59,0,0,1,2.35,5.82h2.9l20.56.11A.2.2,0,0,1,212.2,451.57Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M197.27,446.53a2.49,2.49,0,0,1,3.67-.67c.21.15.41-.19.2-.34a2.89,2.89,0,0,0-4.22.81c-.15.2.2.4.35.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.48,447.2a2.5,2.5,0,0,1,3.68-.67c.2.15.4-.19.2-.34a2.89,2.89,0,0,0-4.22.8c-.15.21.2.41.34.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.77,447.86a2.51,2.51,0,0,1,3.68-.66c.2.15.4-.19.2-.35a2.9,2.9,0,0,0-4.22.81c-.15.21.19.41.34.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "156.92 391.39 158.97 405.15 159.69 410.11 165.79 451.71 162.13 451.71 153.36 410.11 152.32 405.15 149.42 391.39 156.92 391.39",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121.94,
    y1: 422.64,
    x2: 149.94,
    y2: 423.58,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.61 391.39 144.65 405.15 145.38 410.11 151.48 451.71 147.81 451.71 139.04 410.11 138 405.15 135.1 391.39 142.61 391.39",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "142.61 391.39 144.65 405.15 145.38 410.11 151.48 451.71 147.81 451.71 139.04 410.11 138 405.15 135.1 391.39 142.61 391.39"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "74.49 380.94 69.39 405.15 68.35 410.11 59.58 451.71 55.91 451.71 62.02 410.11 62.74 405.15 66.34 380.94 74.49 380.94",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.81 380.94 83.71 405.15 82.66 410.11 73.9 451.71 70.23 451.71 76.33 410.11 77.06 405.15 80.66 380.94 88.81 380.94",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "88.81 380.94 83.71 405.15 82.66 410.11 73.9 451.71 70.23 451.71 76.33 410.11 77.06 405.15 80.66 380.94 88.81 380.94"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M66.28,391.58h90.85l-1.81-7.13c-3-11.95-11.58-20-21.2-20H59.37Z",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.37,345.62l8.61,32,86.61.1-5.34-19.87c-3.56-13.26-15.32-23-29-23.24h-.08c-1-3.83-10.8-40-32.77-39.34-23.2.69-18.17,39.34-18.17,39.34H60.31C56,334.64,52.93,340.26,54.37,345.62Z",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.37,345.62l8.61,32,86.61.1-5.34-19.87c-3.56-13.26-15.32-23-29-23.24h-.08c-1-3.83-10.8-40-32.77-39.34-23.2.69-18.17,39.34-18.17,39.34H60.31C56,334.64,52.93,340.26,54.37,345.62Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M96.73,292.64s2.46,30.89,6.38,40.77c9,22.67,24.69-5.14,24.69-5.14l-10.39-14.89-3-22.9Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.83,313.2l-3.7.78a.38.38,0,0,0,.17.75L117,314a.38.38,0,0,0-.16-.75Z",
    style: {
      fill: "#742823"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.19,286.14s10.14,29.6,13.74,37-10.69,11.79-19.38,9.37-7.32-39-7.32-39Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.37,254.28s-11.57,27.77-5.45,45.46l29-7.92s.14-13-3.43-23.35C134.91,252.22,120.37,254.28,120.37,254.28Z",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.19,351.17c-6-4-6.15-21.27-5-37,.06-4,.23-8.55.57-13.41s.87-10,1.65-15.28h0a147.14,147.14,0,0,1,5.14-23c1.55-4.9,9.6-10,16.9-12.47a39.35,39.35,0,0,1,15.7-1.42,114.06,114.06,0,0,1,11.52,3.52c9.55,3.39,15.6,8.07,15,10.71-.34,1.44,0,9.19-1.79,18.62-.95,5.09-1.56,10.59-2.41,16.12v0s0,.05,0,.1,0,.44-.05.85c-.25,4.55-.82,24.14,6.53,37.64C150,356.4,83.77,357,75.19,351.17Z",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.19,351.17c-6-4-6.15-21.27-5-37,.06-4,.23-8.55.57-13.41s.87-10,1.65-15.28h0a147.14,147.14,0,0,1,5.14-23c1.55-4.9,9.6-10,16.9-12.47a39.35,39.35,0,0,1,15.7-1.42,114.06,114.06,0,0,1,11.52,3.52c9.55,3.39,15.6,8.07,15,10.71-.34,1.44,0,9.19-1.79,18.62-.95,5.09-1.56,10.59-2.41,16.12v0s0,.05,0,.1,0,.44-.05.85c-.25,4.55-.82,24.14,6.53,37.64C150,356.4,83.77,357,75.19,351.17Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M120.35,266.6a7.54,7.54,0,0,1-.91-.07c-8.94-1.25-16.44-18-16.51-18.16a.12.12,0,0,1,.06-.16.13.13,0,0,1,.17.06c.07.17,7.51,16.79,16.32,18,1.52.21,2.57-.1,3.12-.92,2.24-3.39-4.24-14.3-4.31-14.41a.13.13,0,0,1,0-.17.12.12,0,0,1,.17,0c.27.46,6.63,11.16,4.3,14.68A2.75,2.75,0,0,1,120.35,266.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.5,435.65,125.74,435l17.4-62.53s-2.35.46-6.12,1.07c-12.76,2-41.83,5.69-51.58-1.55-14-10.44-13-24.33-13-24.33s111.13-32.51,114-1.18C187.73,360.54,137.5,435.65,137.5,435.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "127.2 433.37 126 444.43 132.02 444.43 136.27 433.37 127.2 433.37",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.72 438.4 124.24 432.55 140.38 432.55 138.87 438.4 123.72 438.4",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.82,452.54c-.84-3.73-2.63-4.85-4.67-5s-10-2.65-10-2.65-1.89-2.37-3.34-2.85a2.61,2.61,0,0,0-2.59.93l-3.85-.47s-1.35-1.69-1.94-.21c-.68,1.71-.45,9.07-.41,10.23Z",
    style: {
      fill: "#D0D0D0"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M151.2,451.57l-4.7,0-20.57-.1a.2.2,0,0,1,0-.4h1.39a.08.08,0,0,1,0-.05c1-2.16-.18-4.34-2.16-5.43-.23-.12,0-.47.2-.34a4.6,4.6,0,0,1,2.36,5.82h2.9l20.56.11A.2.2,0,0,1,151.2,451.57Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M136.26,446.53a2.5,2.5,0,0,1,3.68-.67c.2.15.4-.19.2-.34a2.88,2.88,0,0,0-4.22.81c-.15.2.19.4.34.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.48,447.2a2.49,2.49,0,0,1,3.67-.67c.21.15.41-.19.2-.34a2.89,2.89,0,0,0-4.22.8c-.15.21.2.41.35.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.77,447.86a2.49,2.49,0,0,1,3.67-.66c.21.15.4-.19.2-.35a2.9,2.9,0,0,0-4.22.81c-.15.21.2.41.35.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.11,353.6l-8,18.89s-2.35.46-6.12,1.07C141.71,366.67,150.72,354.11,151.11,353.6Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.88,283.22s-3.76,32-1.67,36.42S137,326.83,137,326.83l2,2.33s-43.63,12.24-59.21.08c-9.19-7.16-7.29-49.51-7.29-49.51Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.06,261.37c-5.25,7.61-7.44,20.63-8.41,32.8L98,292.6S101.12,280,100,269.09c-.68-6.89-4.09-10.15-7.92-11.59C86,255.18,81.79,256,78.06,261.37Z",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.65 336.08 182.94 336.08 184.97 329.25 113.68 329.25 111.65 336.08",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "111.65 336.08 182.94 336.08 184.97 329.25 113.68 329.25 111.65 336.08",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.58,332.55h39.85a3.08,3.08,0,0,0,3-2.29l8-30.11a3.09,3.09,0,0,0-3-3.88H146a4,4,0,0,0-3.89,3l-7.46,28.23A4,4,0,0,0,138.58,332.55Z",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.58,332.55h39.85a3.08,3.08,0,0,0,3-2.29l8-30.11a3.09,3.09,0,0,0-3-3.88H146a4,4,0,0,0-3.89,3l-7.46,28.23A4,4,0,0,0,138.58,332.55Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M141.86,332.55h39.85a3.08,3.08,0,0,0,3-2.29l8-30.11a3.09,3.09,0,0,0-3-3.88H149.32a4,4,0,0,0-3.89,3L138,327.5A4,4,0,0,0,141.86,332.55Z",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.86,332.55h39.85a3.08,3.08,0,0,0,3-2.29l8-30.11a3.09,3.09,0,0,0-3-3.88H149.32a4,4,0,0,0-3.89,3L138,327.5A4,4,0,0,0,141.86,332.55Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M161.9,314.74a3.57,3.57,0,0,0,3.5,4.43,5.4,5.4,0,0,0,5-4.43,3.58,3.58,0,0,0-3.5-4.44A5.41,5.41,0,0,0,161.9,314.74Z",
    style: {
      fill: "#D0D0D0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.9,314.74a3.57,3.57,0,0,0,3.5,4.43,5.4,5.4,0,0,0,5-4.43,3.58,3.58,0,0,0-3.5-4.44A5.41,5.41,0,0,0,161.9,314.74Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M137.66,222.61c-.39,1.1-2,1.35-2,1.35s1.52,1.91.76,2.55-2.41,0-2.41,0a2.49,2.49,0,0,1,.29,2c-.35,1.11-.8.69-.8.69l-24.36-3.91a13,13,0,0,0,0-5.76c-.77-2.63-1.82-6.23-.55-6.87s1.88,0,1.88,0-.1-2.7,1.21-2.92a2.57,2.57,0,0,1,2,.42s.16-1.9,1.35-2.07a1.48,1.48,0,0,1,1.56,1.06s1.37-1.87,2.72-1.9,1.53,1.51,1.53,1.51S123,207,124,207.69a4.63,4.63,0,0,1,1.4,1.95s2.1-2.16,3-1a4.8,4.8,0,0,1,.9,2.7s2.71-2,3.43-.75a4.49,4.49,0,0,1,.39,2.79s2.32-1.27,3,.34a3.09,3.09,0,0,1-.5,3s2.16.26,2.08,1.53-2,2.39-2,2.39S138,221.5,137.66,222.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.57,246.7h0l0,.08-1.7,3.68a12.12,12.12,0,0,0-.45,2.33,12.41,12.41,0,0,0-.05,1.92c.65,1.32.58,4-2.44,3.51-3.81-.65-9.82-7.46-9.77-9.19,2.68-4.89,5.24-10.72,5.83-15.74l3.52,5.47Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M119.52,246.79l-1.7,3.68c-2.2-1.51-4.27-4.3-4.4-6.94-.07-1.9,1.06-3.46,1.81-3.43Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M111.79,223.88a11.19,11.19,0,0,1,18-6c6.68,5.5,4.13,16.54-.42,24.93-4,7.39-14.36,5.63-18.41-2.27-2.69-5.24-1.18-8.64.78-16.61",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126,240.21s-3.69-1-5.4-3.47c0,0-.16,2.92,1.49,4.56S126,240.21,126,240.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.57,224.62s2.41.54,2.15,2.64-.53,2.34-.53,2.34l2.77,1.11s.59-8.09,2.67-7.63.43-3.5,1.78-3.8c3.18-.7,11.29.64,13.56,6.06,0,0,0-5-3.37-8.21s-11-5.16-14.81-1.91S111.57,224.62,111.57,224.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.8,228.05a7.81,7.81,0,0,0,2.19,5.54c1.91,2,4.23.57,4.84-2,.54-2.26.21-6-2.26-7s-4.7.9-4.77,3.43",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.34,231.44c-.2.64,0,1.26.39,1.39s.91-.28,1.11-.91,0-1.26-.39-1.39-.92.28-1.11.91",
    style: {
      fill: "#263238"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M129.34,233.54c-.2.64,0,1.26.39,1.39s.92-.28,1.12-.92,0-1.26-.4-1.39-.91.28-1.11.92"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132.66,231.47a.37.37,0,0,1-.22-.25,1.71,1.71,0,0,0-.7-1.14,2,2,0,0,0-1.32-.2.34.34,0,0,1-.4-.24.32.32,0,0,1,.24-.39,2.64,2.64,0,0,1,1.83.28,2.31,2.31,0,0,1,1,1.56.31.31,0,0,1-.25.38A.33.33,0,0,1,132.66,231.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.75,228.29a.32.32,0,0,1-.14-.53,2.61,2.61,0,0,1,1.68-.76,2.31,2.31,0,0,1,1.68.76.33.33,0,1,1-.46.46,1.71,1.71,0,0,0-1.2-.57,1.94,1.94,0,0,0-1.23.56A.32.32,0,0,1,121.75,228.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.12,231.77a7.16,7.16,0,0,0,1,4c1.17,1.85-2.35,2.05-2.35,2.05Z",
    style: {
      fill: "#ba4d3c"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickSetup);
export default __webpack_public_path__ + "static/media/quickSetup.f113a2158299dcd079ff0244ad56814f.svg";
export { ForwardRef as ReactComponent };